import { render, staticRenderFns } from "./IconLinkSolid.vue?vue&type=template&id=b389ae1c"
import script from "./IconLinkSolid.vue?vue&type=script&lang=js"
export * from "./IconLinkSolid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports